export default {
    root: ({props}) => ({
        class: [
            "relative",

            // Size
            {"h-1 w-full": props.orientation == "horizontal", "w-1 h-56": props.orientation == "vertical"},

            // Shape
            "border-0",

            // Colors
            "bg-stone-100 dark:bg-stone-700",

            // States
            {"opacity-60 select-none pointer-events-none cursor-default": props.disabled},
        ],
    }),
    range: ({props}) => ({
        class: [
            // Position
            "block absolute",
            {
                "top-0 left-0": props.orientation == "horizontal",
                "bottom-0 left-0": props.orientation == "vertical",
            },

            //Size
            {
                "h-full": props.orientation == "horizontal",
                "w-full": props.orientation == "vertical",
            },

            // Colors
            "bg-askr-green",
        ],
    }),
    handle: ({props}) => ({
        class: [
            "block",

            // Size
            "h-8",
            "w-8",
            {
                "-top-3.5": props.orientation == "horizontal",
                "left-[50%] mb-[-0.5715rem] ml-[-0.5715rem]": props.orientation == "vertical",
            },

            // Shape
            "rounded-full",
            "border-2",

            // Colors
            "bg-askr-green",
            "border-askr-green",

            // States
            "hover:bg-askr-green-emphasis",
            "focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring",
            "ring-askr-green-400/50 dark:ring-askr-green-300/50",

            // Transitions
            "transition duration-200",

            // Misc
            "cursor-grab",
            "touch-action-none",
        ],
    }),
    startHandler: ({props}) => ({
        class: [
            "block",

            // Size
            "h-[1.143rem]",
            "w-[1.143rem]",
            {
                "top-[50%] mt-[-0.5715rem] ml-[-0.5715rem]": props.orientation == "horizontal",
                "left-[50%] mb-[-0.5715rem] ml-[-0.4715rem]": props.orientation == "vertical",
            },

            // Shape
            "rounded-full",
            "border-2",

            // Colors
            "bg-askr-green",
            "border-askr-green",

            // States
            "hover:bg-askr-green-emphasis",
            "focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring",
            "focus-visible:ring-askr-green-400/50 dark:focus-visible:ring-askr-green-300/50",

            // Transitions
            "transition duration-200",

            // Misc
            "cursor-grab",
            "touch-action-none",
        ],
    }),
    endHandler: ({props}) => ({
        class: [
            "block",

            // Size
            "h-[1.143rem]",
            "w-[1.143rem]",
            {
                "top-[50%] mt-[-0.5715rem] ml-[-0.5715rem]": props.orientation == "horizontal",
                "left-[50%] mb-[-0.5715rem] ml-[-0.4715rem]": props.orientation == "vertical",
            },

            // Shape
            "rounded-full",
            "border-2",

            // Colors
            "bg-askr-green",
            "border-askr-green",

            // States
            "hover:bg-askr-green-emphasis",
            "focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring",
            "focus-visible:ring-askr-green-400/50 dark:focus-visible:ring-askr-green-300/50",

            // Transitions
            "transition duration-200",

            // Misc
            "cursor-grab",
            "touch-action-none",
        ],
    }),
};
